import React from 'react'
import { Modal } from "antd";
import GainIcon from '../gainicon';

export default function GainModal(props) {
    return (
        <Modal
          title={false}
          visible={props.visible}
          onCancel={props.onCancel}
          centered
          footer={false}
          closable={false}
        >
          <div className="grid grid-cols-2">
              <div className="text-2xl font-bold">{props.title}</div>
              <div className="flex justify-end relative -top-3 -right-3 cursor-pointer" onClick={props.onClose}>
                <GainIcon name="close-modal"/>
              </div>
          </div>
          {props.children}
        </Modal>
    )
}
